import {
  addBudgetSubject,
  addBudgetSubjectType,
  carryOverSubject,
  carryOverSubjectSettings,
  carryOverSubjectSettingsInfo,
  deleteBudgetSubject,
  deleteBudgetSubjectType,
  editBudgetSubject,
  editBudgetSubjectType,
  getBudgetSubjectDetail,
  getBudgetSubjectDownList,
  getBudgetSubjectDownListV2,
  getBudgetSubjectList,
  getBudgetSubjectTypeDownList,
  getBudgetSubjectTypeList,
  getcarryOverSubject,
  unTransferSubject,
} from '../services';

export default {
  namespace: 'budgetSubject',
  state: {
    // 科目类型列表
    budgetSubjectTypeList: [],
  },
  effects: {
    // 获取预算科目列表
    *getBudgetSubjectList({ payload }, { call }) {
      return yield call(getBudgetSubjectList, payload);
    },
    // 获取预算科目下拉，添加科目时需要
    *getBudgetSubjectDownList({ payload }, { call }) {
      return yield call(getBudgetSubjectDownList, payload);
    },
    // 获取预算科目下拉框 用于模板
    *getBudgetSubjectDownListV2({ payload }, { call }) {
      return yield call(getBudgetSubjectDownListV2, payload);
    },
    // 新增科目
    *addBudgetSubject({ payload }, { call }) {
      return yield call(addBudgetSubject, payload);
    },

    // 编辑科目
    *editBudgetSubject({ payload }, { call }) {
      return yield call(editBudgetSubject, payload);
    },
    // 删除科目
    *deleteBudgetSubject({ payload }, { call }) {
      return yield call(deleteBudgetSubject, payload?.uk);
    },

    // 科目类型列表
    *getBudgetSubjectTypeList({ payload }, { call, put }) {
      const result = yield call(getBudgetSubjectTypeList, payload);

      yield put({
        type: 'update',
        payload: {
          budgetSubjectTypeList: result || [],
        },
      });
    },

    // 科目类型_下拉框
    *getBudgetSubjectTypeDownList({ payload }, { call }) {
      return yield call(getBudgetSubjectTypeDownList, payload);
    },

    // 科目类型_删除
    *deleteBudgetSubjectType({ payload }, { call }) {
      return yield call(deleteBudgetSubjectType, payload.code);
    },

    // 新增科目类型
    *addBudgetSubjectType({ payload }, { call }) {
      return yield call(addBudgetSubjectType, payload);
    },
    // 编辑科目类型
    *editBudgetSubjectType({ payload }, { call }) {
      return yield call(editBudgetSubjectType, payload);
    },
    // 反结转
    *unTransferSubject({ payload }, { call }) {
      return yield call(unTransferSubject, payload);
    },
    // 批量查询已结转科目编码
    *getcarryOverSubject({ payload }, { call }) {
      return yield call(getcarryOverSubject, payload);
    },
    // 结转科目
    *carryOverSubject({ payload }, { call }) {
      return yield call(carryOverSubject, payload);
    },
    // 预算科目详情
    *getBudgetSubjectDetail({ payload }, { call }) {
      return yield call(getBudgetSubjectDetail, payload);
    },
    // 结转科目设置-设置
    *carryOverSubjectSettings({ payload }, { call }) {
      return yield call(carryOverSubjectSettings, payload);
    },

    // 结转科目设置-详情
    *carryOverSubjectSettingsInfo({ payload }, { call }) {
      return yield call(carryOverSubjectSettingsInfo, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
